export const LOCAL_STORAGE_KEYS = {
  SERVICES_LIST_FILTERS: 'services_list_filters',
  USER_ACTIVITY_LOGS_LIST_FILTERS: 'user_activity_logs_list_filters',
  ORDERS_INFO_FILTERS: 'orders_info_filters',
  ALL_BOOKINGS_FILTERS: 'all_bookings_filters',
  BOOKING_EVENTS_VIEW_MODE: 'booking_events_view_mode',
  ADMIN_UI_VERSION: 'admin_ui_version',
} as const;

export const getAdminThemeStorageKey = (userName: string) =>
  `admin_theme_${encodeURIComponent(userName)}`;
